import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

/**
 * Gate admin routes behind an authenticated session.
 *   user === null    → still bootstrapping (show a thin shell, NOT a redirect —
 *                       a redirect here would race the /me check and bounce a
 *                       freshly-loaded /admin page to /login briefly)
 *   user === false   → confirmed anonymous → redirect to /admin/login
 *   user === object  → render the protected tree
 */
export default function RequireAuth({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div
        data-testid="requireauth-loading"
        className="min-h-screen flex items-center justify-center bg-zinc-950 text-zinc-500 font-mono text-sm"
      >
        verifying session…
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
}
